import {
	EnhancedBanner,
	EnhancedBannerProps,
} from '../../../../libraries/design/components/enhanced-banner/src/enhanced-banner';

export type UniformEnhancedBannerProps = EnhancedBannerProps;

const UniformEnhancedBanner = (props: UniformEnhancedBannerProps) => {
	return <EnhancedBanner {...props} />;
};

export default UniformEnhancedBanner;
